/**
 * Motor "comparar" — escolher entre dois grupos qual tem mais/menos.
 *
 * D13: a comparacao e sempre CONCRETA. Sao dois montes de objetos de verdade
 *      no cenario, nunca dois numerais. A crianca compara o que ve.
 * D6: apontar o grupo que nao era nao e erro; o jogo convida a olhar de novo.
 */

import * as THREE from 'three';
import { BaseEngine } from './BaseEngine.js';

export class CompararEngine extends BaseEngine {
  constructor(ctx) {
    super(ctx);
    this.grupos = [];
    this.grupo = null;
    this.acertou = false;
  }

  async iniciar(tarefa, banda) {
    await super.iniciar(tarefa, banda);

    const payload = tarefa.bandas[String(banda)];
    if (!payload) {
      throw new Error(`FAZENDA: a tarefa "${tarefa.id}" nao tem payload para a banda ${banda}.`);
    }

    this.criterio = payload.criterio; // "mais" | "menos"
    const diferencaMinima = payload.diferenca_minima;

    // Sorteia duas quantidades com a diferenca minima pedida.
    const menor = 2 + Math.floor(Math.random() * 5);
    const maior = menor + diferencaMinima + Math.floor(Math.random() * 3);
    this.quantidades = Math.random() < 0.5 ? [menor, maior] : [maior, menor];

    this.montar();
    console.info(
      `FAZENDA: tarefa "${tarefa.id}" iniciada — banda ${banda}, ` +
        `criterio "${this.criterio}", grupos de ${this.quantidades.join(' e ')}.`
    );
  }

  montar() {
    const { fazenda, sceneManager, input } = this.ctx;

    this.grupo = new THREE.Group();
    this.grupo.name = 'tarefa-comparar';
    const base = fazenda.posicaoDaAncora(this.tarefa.ancora);

    this.quantidades.forEach((quantidade, lado) => {
      const conjunto = new THREE.Group();
      const centroX = base.x + (lado === 0 ? -2.6 : 2.6);

      // A base clicavel: um tapete grande embaixo do monte, para o alvo ser
      // enorme e o dedo nao precisar acertar um objeto pequeno (D3).
      const tapete = new THREE.Mesh(
        new THREE.BoxGeometry(3.4, 0.1, 3.4),
        new THREE.MeshStandardMaterial({
          color: lado === 0 ? 0xffe0b2 : 0xb3e5fc,
          roughness: 1,
          flatShading: true,
        })
      );
      tapete.position.set(centroX, base.y + 0.05, base.z + 2.2);
      conjunto.add(tapete);

      for (let i = 0; i < quantidade; i++) {
        const objeto = new THREE.Mesh(
          new THREE.IcosahedronGeometry(0.3, 0),
          new THREE.MeshStandardMaterial({ color: 0xf9d71c, roughness: 0.9, flatShading: true })
        );
        objeto.position.set(
          centroX - 1.1 + (i % 4) * 0.75,
          base.y + 0.35,
          base.z + 1.4 + Math.floor(i / 4) * 0.75
        );
        conjunto.add(objeto);
      }

      conjunto.userData.quantidade = quantidade;
      conjunto.userData.lado = lado;

      this.grupo.add(conjunto);
      this.grupos.push(conjunto);
      input.registrar(conjunto, () => this.aoEscolherGrupo(conjunto));
    });

    sceneManager.adicionar(this.grupo);
    input.conferirTamanhoDeAlvo(this.grupos[0], `grupo da tarefa ${this.tarefa.id}`);
  }

  grupoCerto() {
    const [a, b] = this.quantidades;
    const indice = this.criterio === 'mais' ? (a > b ? 0 : 1) : a < b ? 0 : 1;
    return this.grupos[indice];
  }

  aoEscolherGrupo(conjunto) {
    const { audio, instrucao, input } = this.ctx;
    this.tentativas += 1;

    if (conjunto === this.grupoCerto()) {
      this.acertou = true;
      audio.tocarSucesso();
      for (const g of this.grupos) input.desregistrar(g);
      return;
    }

    // D6 — convite a olhar de novo, sem som de erro.
    audio.tocarTentarDeNovo();
    instrucao.mostrarTexto('Olha os dois montes de novo com calma.');
  }

  concluiu() {
    return this.acertou;
  }

  atualizar(dt) {
    for (const g of this.grupos) g.rotation.y += dt * 0.12;
  }

  async concluir() {
    return super.concluir({ concluiu: this.acertou });
  }

  descartar() {
    const { input, sceneManager } = this.ctx;
    for (const g of this.grupos) input.desregistrar(g);
    if (this.grupo) {
      sceneManager.remover(this.grupo);
      this.grupo.traverse((o) => { o.geometry?.dispose(); o.material?.dispose(); });
    }
    this.grupos = [];
    this.grupo = null;
    this.acertou = false;
    super.descartar();
  }
}
